import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _FinishedContracts } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";



export const FinishedEmployeeContracts = () => {

    const Finished = useDataBean(_FinishedContracts);
    const single = Singleton.getInstance();
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [yeartwo, setyeartwo] = useState<number>(_single.getCurrenYear())
    const [lista, setLista] = useState<any>([]);
    const [funcionario, setFuncionario] = useState<number>(null);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        Finished.instance.getFinishedEmployeeContracts(year, yeartwo, funcionario, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        Finished.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Finished.deleteItemVoid(Finished.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        Finished.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Perfil de Liquidación', property: 'IDEmployeeLiquidate', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'ContractTypeName', visible: true },
        { title: 'Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: true },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: true },
        // { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        // { title: 'Tipo de Payrol', property: 'PayrollTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'EPS', property: 'EPSName', visible: true },
        { title: 'ARP', property: 'ARPName', visible: true },
        { title: 'CCF', property: 'CCFName', visible: true },
        { title: 'Fondo Pensional', property: 'FPName', visible: true },
        { title: 'Fondo Cesantías', property: 'FCEName', visible: true },
        { title: 'Tipo de Salario', property: 'RevenueType', visible: true },
        { title: 'Salario', property: 'Revenue', mask: MASK_MONEY, visible: true },
        { title: 'Usar Salario Definido en el Contrato', property: 'UseContractSalaryValue', visible: true },
        { title: 'Salario Definido por Contrato', property: 'ContractSalaryValue', mask: MASK_MONEY, visible: true },
        { title: 'Tipo Riesgo', property: 'ARPRiskName', visible: true },
        { title: 'Tipo Cotizante', property: 'EmployeeTypeName', visible: true },
        { title: 'Subtipo Cotizante', property: 'EmployeeSubtypeName', visible: true },
        { title: 'Fecha Renuncia', property: 'EndingDate', mask: MASK_DATE, visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Fecha Liquidación', property: 'UptoContract', mask: MASK_DATE, visible: true },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: true },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Resposable ImpoRenta', property: 'RentTax', visible: true },
        { title: 'Último Exámen Médico', property: 'HealthTestDate', mask: MASK_DATE, visible: true },
        { title: 'Últimas Vacaciones', property: 'LastVacDate', mask: MASK_DATE, visible: true },
        { title: 'Última Dotación', property: 'LastEndowmentDate', mask: MASK_DATE, visible: true },
        { title: 'Tipo de Empleo', property: 'EmploymentTypeName', visible: true },
        { title: 'Código CIIU', property: 'CIIUCode', mask: MASK_NUMBER, visible: true },
        { title: 'Subtipo ARL', property: 'ARPRiskName', visible: true },
        { title: 'Tipo de Contrato', property: 'EmployeeContractType', visible: true },
        { title: 'Definir Límite de UVTs', property: 'UseUVTMaxRetefuente', visible: true },
        { title: 'Limite UVTs', property: 'UVTMaxRetefuente', visible: true },
        { title: 'Ciudad de Ejecución del Contrato', property: 'SiteIDName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Método de Cálculo', property: 'IDTaxRetentionMethodName', visible: true },
        { title: '% Fijo de Retención para el Procedimiento 2', property: 'TaxRetentionPercent2', visible: true },
        { title: 'Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Definir Centro de Costo', property: 'UseOwnCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Reporte de Contratos Terminados">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año Desde" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <YearSelector value={yeartwo} tittle="Año Hasta" onChange={(e) => { setyeartwo(e) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={funcionario} onChange={(e) => { setFuncionario(e.IDAccount) }} label="Empleado" />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Consultar
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={Finished.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Finished.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}